import { useCallback, useRef } from 'react';

import useStableCallback from 'src/hooks/useStableCallback';
import { supportsHover } from 'src/utils/device';

/**
 * 특정 진입점을 기반으로 preload를 적용하고 싶을 때 활용하는 훅
 * 호버 효과를 지원하는 환경의 경우 해당 진입점을 호버할 때, 그렇지 않으면 진입점이 렌더링될 때 preload 실행
 */
const usePreloadByEntryPoint = (preload: () => void) => {
  const isPreloadedRef = useRef(false);

  const stablePreload = useStableCallback(() => {
    if (isPreloadedRef.current) return;
    preload();
    isPreloadedRef.current = true;
  });

  const nodeRef = useRef<HTMLElement | null>(null);

  const entryPointRef = useCallback(
    (node: HTMLElement | null) => {
      const prev = nodeRef.current;
      if (prev) {
        prev.removeEventListener('mouseenter', stablePreload);
      }
      nodeRef.current = node;
      if (node) {
        if (supportsHover()) {
          node.addEventListener('mouseenter', stablePreload, {
            once: true,
          });
        } else {
          stablePreload();
        }
      }
    },
    [stablePreload]
  );

  return entryPointRef;
};

export default usePreloadByEntryPoint;
